<template>
  <div v-if="showOverlay === 'fullscreenImage' && (url || globalImageUrl)" class="fixed top-0 left-0 w-screen h-screen z-50 flex flex-row justify-center items-center" @click="closeFullscreenImage">
    <div class="absolute top-12 md:right-12 bg-white rounded-full w-12 h-12 flex flex-row justify-center items-center font-bold border-2 border-black">X</div>
    <div v-if="globalImageUrl" class="w-full h-full bg-contain bg-no-repeat bg-center" :style="{ backgroundImage: 'url(' + globalImageUrl + ')' }"
    @touchstart.passive="touchStart"
    @touchend.passive="touchEnd"
    @touchmove.prevent="touchMove"></div>
    <div v-else class="w-full h-full bg-contain bg-no-repeat bg-center" :style="{ backgroundImage: 'url(' + url + ')' }"
    @touchstart.passive="touchStart"
    @touchend.passive="touchEnd"
    @touchmove.prevent="touchMove"></div>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js';

// Mixins
import iosVibrations from '../mixins/iosVibrations.vue';

export default {
  name: 'fullscreenImage',
  props: ['url'],
  mixins: [iosVibrations],

  data() {
    return {
      initialX: null,
      initialY: null,
      lastTranslateX: null,
      lastTranslateY: null,
      currentX: null,
      currentY: null,
      dragItem: null,
      pinching: false,
      dist: 1,
    };
  },

  computed: {
    showOverlay() {
      return this.$store.state.layout.showOverlay;
    },
    globalImageUrl() {
      return this.$store.state.learning.globalImageUrl;
    },
  },

  watch: {
    showOverlay() {
      if (this.showOverlay === 'fullscreenImage') {
        this.dist = 1;
      }
    },
  },

  beforeUnmount() {
    this.$store.commit('showOverlay', null);
  },

  methods: {

    touchStart(e) {
      this.dragItem = e.srcElement;
      this.initialX = e.touches[0].clientX;
      this.initialY = e.touches[0].clientY;
      if (e.touches.length === 2) {
        this.pinching = true;
      }
    },

    touchMove(e) {
      this.currentX = e.touches[0].clientX - this.initialX + this.lastTranslateX;
      this.currentY = e.touches[0].clientY - this.initialY + this.lastTranslateY;
      if (this.pinching) {
        this.dist = Math.hypot(
          e.touches[0].pageX - e.touches[1].pageX,
          e.touches[0].pageY - e.touches[1].pageY,
        );
        if (this.dist > 1) this.dist /= 100;
      }
      e.preventDefault();
      anime.set(this.dragItem, {
        translateX: this.currentX,
        translateY: this.currentY,
        scale: this.dist,
      });
    },

    touchEnd() {
      if (this.pinching) this.pinching = false;
      this.lastTranslateX = this.currentX;
      this.lastTranslateY = this.currentY;
      /* anime({
        targets: this.dragItem,
        easing: 'easeInOutCubic',
        duration: 250,
        translateX: 0,
        translateY: 0,
      }); */
    },

    closeFullscreenImage() {
      this.lastTranslateX = null;
      this.lastTranslateY = null;
      this.iosVibrate(0);
      this.$store.commit('setGlobalImageUrl', null);
      this.$store.commit('showOverlay', null);
    },
  },
};
</script>
